
  import {
    Component,
    Vue
  } from 'vue-property-decorator'
  @Component({
    name: 'AuthEndSessionRedirectView',
  })
  export default class AuthEndSessionRedirectView extends Vue {}
